<template>
<div class="form-row" :class="{ hasError: showErrors && hasError }">
  <div class="form-item form-item-25">
    <label>{{ $t('form.telephone.fld_prefix') }}<span style="display:inline;" v-if="isRequired"> *</span></label>
    <select v-model="prefix"
            name="telephone"
            :required="isRequired"
            @change="update(telephone)">
      <option disabled value='default'>{{ $t('form.telephone.fld_prefix_default') }}</option>
      <template v-for="(opt, i) in getCountryCodes">
        <option :value="opt.prefix" :key="i">
          {{ $t('form.telephone.fld_prefix_' + opt.code) }}
        </option>
      </template>
      <option value='other'>{{ $t('form.telephone.fld_prefix_other') }}</option>
    </select>
  </div>
  <div class="form-item form-item-40">
    <label>{{ $t('form.telephone.fld_tnumber') }}<span style="display:inline;" v-if="isRequired"> *</span></label>
    <input
      name="telephone"
      type="tel"
      minlength="5" maxlength="18"
      :required="isRequired"
      v-bind:value="telephone"
      v-on:input="update($event.target.value)" />
  </div>
</div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'TelephoneInput',
  data() {
    return {
      prefix: "default",
      telephone: ""
    };
  },
  props: {
    showErrors: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      required: true,
      default: false
    },
    value: {
      type: String,
      required: true,
      default: ""
    },
    countryPrefix: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      getCountryCodes: "getCountryCodes"
    }),
    hasError() {
      return this.isRequired ? !this.telephone : false;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.value !== null) {
        let pre;
        let re = '';
        let that = this;
        if (this.countryPrefix) {
          this.prefix = this.countryPrefix;
          re = this.getCountryCodes.find( (el) => { return el.prefix === that.countryPrefix }).regexp;
        } else if (( pre = this.getCountryCodes.find( (el) => { return el.regexp.test(that.value) }))) {
          this.prefix = pre.prefix;
          re = pre.regexp;
        } else { this.prefix = 'other';}
        this.telephone = this.value.replace( re, '');
      }
    },
    update(val) {
      var rv = val;
      if (this.prefix !== 'other' && this.prefix !== 'default') {
        let that = this;
        let re = this.getCountryCodes.find( (el) => { return el.prefix === that.prefix }).regexp;
        rv = rv.replace(re, '');
        rv = rv.replace(/^0/, '');
        this.telephone = rv;
        rv = this.prefix + rv
      }
      if (this.prefix === "other") {
        if ( !rv.startsWith("+")) { return }
      }
      this.$emit('upd:telephone', rv);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
